import script from "./EmptyError.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmptyError.vue?vue&type=script&lang=ts&setup=true"

import "./EmptyError.vue?vue&type=style&index=0&id=2649cb63&scoped=true&lang=css"

import exportComponent from "/builds/digitalize/web/rkhy/rkhy-recruitment/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2649cb63"]])

export default __exports__